const routes = [
  {
    dividerTitle: "Trámites",
  },
  {
    path: "/tramites-por-fecha",
    name: "Trámites por Fecha de Atención",
    component: () => import("@/views/reportes/TramitesPorFecha.vue"),
    meta: { title: "Trámites por Fecha" },
  },
  {
    dividerTitle: "Trámites por semanas",
  },
  {
    path: "/tramites-asignaciones",
    name: "Asignaciones",
    component: () => import("@/views/reportes/TramitesAsignaciones.vue"),
    meta: { title: "Asignaciones" },
  },
  {
    path: "/tramites-avance",
    name: "Avance de Trámites",
    component: () => import("@/views/reportes/TramitesAvances.vue"),
    meta: { title: "Avance de Trámites" },
  },
  {
    path: "/tramites-avance-am",
    name: "Avance de A.M.",
    component: () => import("@/views/reportes/TramitesAvancesAM.vue"),
    meta: { title: "Avance de A.M." },
  },
  {
    path: "/tramites-avance-gd",
    name: "Avance de G.D.",
    component: () => import("@/views/reportes/TramitesAvancesGD.vue"),
    meta: { title: "Avance de G.D." },
  },
  {
    path: "/tramites-tiempo-proceso",
    name: "Tiempo Procesamiento",
    component: () => import("@/views/reportes/TramitesTiempoProceso.vue"),
    meta: { title: "Tiempo Procesamiento" },
  },
  {
    path: "/tramites-estadisticas",
    name: "Trámites estadísticas",
    component: () => import("@/views/reportes/TramitesEstadisticas.vue"),
    meta: { title: "Trámites estadísticas" },
  },
  {
    path: "/especialidades-prestador",
    name: "Especialidades Prestador",
    component: () => import("@/views/reportes/EspecialidadesPrestador.vue"),
    meta: { title: "Especialidades Prestador" },
  },
  {
    path: "/tarifario-prestador",
    name: "Tarifario Prestador",
    component: () => import("@/views/reportes/TarifarioPrestador.vue"),
    meta: { title: "Tarifario Prestador" },
  },
  {
    path: "/tarifario-prestador-ext",
    name: "Tarifario Prestador Ext.",
    component: () => import("@/views/reportes/TarifarioPrestadorExt.vue"),
    meta: { title: "Tarifario Prestador Ext." },
  },
];

export { routes };
